import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyles = () => {
    const {orbitalFour} = useWolfTheme();
    return useMemo(
        () => ({
            fileImport: css({
                display: 'grid',
                gridTemplateColumns: '3fr 1fr',
                gridColumnGap: orbitalFour,
                gridRowGap: orbitalFour,
                alignItems: 'top',
                marginBottom: orbitalFour,
            }),
            filePicker: css({
                maxWidth: '272px',
            }),
        }),
        [orbitalFour]
    );
};

export default useStyles;
